module.exports = __webpack_public_path__ + "assets/img/40.421cdbf8.png";